/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Preset_1hInputs */

const en_usage_preset_1h = /** @type {(inputs: Usage_Preset_1hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last hour`)
};

const zh_hans1_usage_preset_1h = /** @type {(inputs: Usage_Preset_1hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近 1 小时`)
};

const pt_br2_usage_preset_1h = /** @type {(inputs: Usage_Preset_1hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última hora`)
};

const es_usage_preset_1h = /** @type {(inputs: Usage_Preset_1hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última hora`)
};

const fr_usage_preset_1h = /** @type {(inputs: Usage_Preset_1hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière heure`)
};

const de_usage_preset_1h = /** @type {(inputs: Usage_Preset_1hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Stunde`)
};

const ru_usage_preset_1h = /** @type {(inputs: Usage_Preset_1hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последний час`)
};

const it_usage_preset_1h = /** @type {(inputs: Usage_Preset_1hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima ora`)
};

/**
* | output |
* | --- |
* | "Last hour" |
*
* @param {Usage_Preset_1hInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const usage_preset_1h = /** @type {((inputs?: Usage_Preset_1hInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Preset_1hInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_usage_preset_1h(inputs)
	if (locale === "pt-BR") return pt_br2_usage_preset_1h(inputs)
	if (locale === "es") return es_usage_preset_1h(inputs)
	if (locale === "fr") return fr_usage_preset_1h(inputs)
	if (locale === "de") return de_usage_preset_1h(inputs)
	if (locale === "ru") return ru_usage_preset_1h(inputs)
	if (locale === "it") return it_usage_preset_1h(inputs)
	return en_usage_preset_1h(inputs)
});